import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import ReservationActions, { ReservationRedux, ReservationTypes } from '../../Redux/ParentPlatform/ReservationRedux'
import { notificationSuccess, notificationFail } from '../../Redux/NotificationActions'

const ReservationCRUDObservable = createCRUDObservable({
  mainRedux: ReservationRedux,
  reduxPath: 'parent_platform_reservation',
})

// const createMedicineEpic = (action$, store, { Api }) => (
//   action$.ofType(MedicineTypes.createReservationRequest)
//     .mergeMap(({ reservationInfo }) => (
//       Api.parent_platform_medicine.create(medicineInfo)
//         .then(response => response)
//         .catch(err => err)
//     ))
//     .flatMap((response) => {
//       const { status } = response
//       if (!(status >= 200 && status < 300)) {
//         return [
//           ReservationActions.createReservationrror(response.error),
//           notificationFail('Accion Fallida'),
//         ]
//       }
//       return [
//         ReservationActions.createMedicineSuccess(response.data.data),
//         MedicinesActions.updateMedicines(response.data.data),
//         notificationSuccess('Accion Exitosa'),
//       ]
//     })
// )

const postReservationeEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationTypes.postReservationRequest)
    .mergeMap(({studentId, data }) => 
      Observable.fromPromise(
        Api.parent_platform_reservation.postReservation(studentId, data)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationActions.postReservationError(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response.data
          return [
            ReservationActions.postReservationSuccess(data),
            notificationSuccess('Reservación guardada exitosamente.'),
          ]
        }
      ),
)

const updateReservationEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationTypes.updateReservationRequest)
    .mergeMap(({ id,data }) => 
      Observable.fromPromise(
        Api.parent_platform_reservation.updateResevation(id,data)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationActions.updateReservationError(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response.data
          return [
            ReservationActions.updateReservationSuccess(data,id),
            notificationSuccess('Reservación actualizado exitosamente.'),
          ]
        }
      ),
)
const deleteReservationEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationTypes.deleteReservationRequest)
    .mergeMap(({ id }) => 
      Observable.fromPromise(
        Api.parent_platform_reservation.deleteReservation(id)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationActions.deleteReservationFaile(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response.data
          return [
            ReservationActions.deleteReservationSuccess(id),
            notificationSuccess('Reservación eliminada exitosamente.'),
          ]
        }
      ),
)

export const reservationObservers = Object.assign({}, ReservationCRUDObservable.observers, {})
export const reservationEpic = combineEpics(
  ReservationCRUDObservable.epic,
  postReservationeEpic,
  updateReservationEpic,
  deleteReservationEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ParentPlatform/ReservationObserver.js